<template>
  <div class="w-full mx-auto">
    <!-- Label -->
    <div class="flex justify-between items-center mb-2">
      <span class="text-sm font-medium text-[var(--mt-text-muted)]">
        Confidence
      </span>

      <!-- Status Text -->
      <div class="flex items-center gap-1.5 text-sm font-medium" :style="{ color: labelColor }">
        <MTIcon :name="statusIconName" :size="16" />
        {{ statusText }}
      </div>

      <span
        class="text-sm font-semibold"
        :style="{ color: labelColor }">
        {{ Math.round(confidence) }}%
      </span>
    </div>
    <!-- Meter Container -->
    <div class="relative w-full h-4 bg-[var(--mt-track-bg)] rounded-full overflow-hidden">
      <!-- Animated Fill -->
      <div
        class="h-full rounded-full transition-all duration-700 ease-out"
        :style="{
          width: confidence + '%',
          background: meterGradient
        }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import MTIcon from "@/components/ui/MTIcon.vue";

/**
 * Props
 * confidence: Number 0–100
 */
const props = defineProps({
  confidence: {
    type: Number,
    required: true
  }
});

/* ------------------------------
    GRADIENT + STATUS LABELS
------------------------------ */

const meterGradient = computed(() => {
  if (props.confidence < 30)
    return "linear-gradient(90deg, #f43f5e, #fb7185)"; // red → pink
  if (props.confidence < 60)
    return "linear-gradient(90deg, #f59e0b, #fbbf24)"; // amber → yellow
  if (props.confidence < 85)
    return "linear-gradient(90deg, #3b82f6, #60a5fa)"; // blue tones
  return "linear-gradient(90deg, #22c55e, #4ade80)";   // green tones
});

const labelColor = computed(() => {
  if (props.confidence < 30) return "#f43f5e";  // red
  if (props.confidence < 60) return "#f59e0b";  // amber
  if (props.confidence < 85) return "#3b82f6";  // blue
  return "#22c55e";                             // green
});

const statusText = computed(() => {
  if (props.confidence < 20) return "Getting Started";
  if (props.confidence < 40) return "Learning";
  if (props.confidence < 60) return "Improving";
  if (props.confidence < 80) return "Strong Understanding";
  return "Confident! Ready to move on";
});

const statusIconName = computed(() => {
  if (props.confidence < 20) return "star";      // beginner
  if (props.confidence < 40) return "sprout";    // growing
  if (props.confidence < 60) return "book-open"; // learning
  if (props.confidence < 80) return "rocket";    // confident
  return "trophy";                               // mastery
});
</script>
